import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'
import FieldGroup from '../../../../common/forms/FieldGroup'
import SubmitButton from '../../../../common/forms/SubmitButton'
import LinkActionButton from '../../../../common/Buttons/LinkActionButton'
import history from '../../../../core/history'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdviserAdd.scss'

const AdviserAdd = ({
  submittingAdviser,
  adviser = {},
  validationstate,
  setIfaCode,
  setFirstName,
  setMiddleName,
  setLastName,
  submitNewAdviser,
  children
}) => {

  const handleBlur = (event, callback) => {
    callback(event.target.value)
  }

  const goToAdvisers = () => {
    history.push('/administration/whitelisting')
  }

  return (
    <div className={styles['wrapper']}>

      {/* ✅ Heading */}
      <h1 className={styles['heading']}>
        Add Adviser
      </h1>

      {/* ✅ Form */}
      <form>
        <Form.Group controlId="adviser-add-form">

          {/* IFA CODE */}
          <FieldGroup
            id="adviser-add-ifa-code"
            label="IFA Code"
            required
            value={adviser.ifaCode || ''}
            isInvalid={validationstate?.ifaCode?.isInvalid}
            message={validationstate?.ifaCode?.help}
            handleChange={setIfaCode}
            onBlur={(event) => handleBlur(event, setIfaCode)}
          />

          {/* FIRST NAME */}
          <FieldGroup
            id="adviser-add-first-name"
            label="First Name"
            required
            value={adviser.firstName || ''}
            isInvalid={validationstate?.firstName?.isInvalid}
            message={validationstate?.firstName?.help}
            handleChange={setFirstName}
            onBlur={(event) => handleBlur(event, setFirstName)}
          />

          {/* MIDDLE NAME */}
          <FieldGroup
            id="adviser-add-middle-name"
            label="Middle Name"
            value={adviser.middleName || ''}
            handleChange={setMiddleName}
          />

          {/* LAST NAME */}
          <FieldGroup
            id="adviser-add-last-name"
            label="Last Name"
            required
            value={adviser.lastName || ''}
            isInvalid={validationstate?.lastName?.isInvalid}
            message={validationstate?.lastName?.help}
            handleChange={setLastName}
            onBlur={(event) => handleBlur(event, setLastName)}
          />

          {/* ✅ Button Row */}
          <div className={styles['button-row']}>

            <SubmitButton
              onClick={() => submitNewAdviser(adviser)}
              isValid={validationstate?.formIsValid}
              preventDefault
              isSubmitting={submittingAdviser}
              buttonText="Add Adviser"
            />

        
<span
  onClick={goToAdvisers}
  className={styles['cancel-link']}
>
  Cancel
</span>


          </div>

          {children}

        </Form.Group>
      </form>

    </div>
  )
}

AdviserAdd.propTypes = {
  submittingAdviser: PropTypes.bool,
  adviser: PropTypes.object,
  validationstate: PropTypes.object,
  setIfaCode: PropTypes.func.isRequired,
  setFirstName: PropTypes.func.isRequired,
  setMiddleName: PropTypes.func.isRequired,
  setLastName: PropTypes.func.isRequired,
  submitNewAdviser: PropTypes.func.isRequired,
  children: PropTypes.node
}

export default withStyles(styles)(AdviserAdd)
